<template>
<div v-bind:class="{'locked':token === null}">

	<ul class="title-nav">
		<li v-on:click="handleBack()">
			<div class="back-btn">
				<i class="material-icons md-18">keyboard_arrow_left</i>
			</div> 
			
			<div class="title-label"><i class="material-icons md-18">{{getCategoryIcon(category)}}</i> {{category.toUpperCase()}} ({{overlays.length}})</div>
		</li>
	</ul>

	<div v-if="token === null" v-on:click="routeLogin" class="lock-block">
		<div class="lock-icon-box">
			<i class="material-icons md-36">account_box</i>
		</div>
		<div class="lock-text">
			<h5 class="mb-0 text-white">Sign in to view overlays</h5>
			<h5 class="mb-0 font-weight-light text-light">Get details on parcel capabilities</h5>
		</div>
	</div>

	<div v-if="overlays.length === 0" class="section-title text-center">
		No {{category}} overlays for this parcel
	</div>
	<div class="section" v-for="(source, index) in overlays">
		<div class="section-title property-locked">
			<span>
				<span class="link" v-on:click="routeOverlay(source.features[0])">{{source.name}}</span>
				<a v-if="deviceType !== 'mobile'" v-on:click="overlayLayerToggle(source)" class="visible-icon float-right" 
					v-bind:class="{active:overlaysVisible[overlayKey(source)]}" href="javascript:">
					<i class="material-icons md-18">visibility</i>
				</a>
			</span>
		</div>
		<div class="section-body">
			<div class="category">
				<div class="category-title">DESCRIPTION</div>
				<div class="property-row">
					<div class="text-break property-locked">
						{{source.description || 'No description available'}}
					</div>
				</div>
			</div>
			<div v-for="(overlay, index) in source.features" class="feature">
				<div v-if="overlay.details" class="category">
					<div class="category-title">
						DETAILS 
						<span v-if="source.features.length > 1">({{index+1}})</span>
					</div>
					<div v-for="(detail, index) in overlay.details" class="property-row">
						<label>{{detail.name}}</label>
						<div class="property-value-right property-locked">
							{{detail.value}}
						</div>
					</div>
				</div>
				<div v-if="isReference(overlay)" class="category">
					<div class="category-title">
						REFERENCES 
						<span v-if="source.features.length > 1">({{index+1}})</span>
					</div>
					<div v-for="(ref, idx) in overlay.references" class="property-row">
						<label>{{ref.description}}</label>
						<div class="property-value-right">
							<a :href="ref.url" target="_blank"><i class="material-icons md-12">open_in_new</i> Link</a>
						</div>
					</div>
				</div>
			</div>
			<div class="over-action d-flex" v-if="token === null" v-on:click="routeLogin">
				<div class="over-action-box align-self-center text-white hover-dk">
					<div class="text-center">
						<i class="material-icons text-light md-36">account_box</i>
					</div>
					<div class="text-center">
						Sign in to view
					</div>
				</div>
			</div>
		</div>		
	</div>
</div>

</template>

<script>
import {mapActions} from 'vuex';
import overlayIcons from '../../config/overlay-icons';

export default {
	props: {
		addressId: Number,
		category: String,
		handleBack: {
			type:Function,
			required:true
		},
		parcel:{
			type:Object,
			required:true,
		},
	},
	computed:{
		token: function(){
			return this.$store.state.agent.token;
		},
		deviceType: function(){
			return this.$store.state.device.type;
		},
		zoomToDone:function(){
			return this.$store.state.map.flyToDone;
		},
		overlays: function(){
			return this.parcel.overlaySources.filter((overlay)=>overlay.category === this.category)
		}
	},
	created:function(){
		this.$store.dispatch('MAP_LAYER_GROUP_VISIBLE_OFF','zoning');
	},
	data:function(){
		return {
			overlaysVisible:{},
			zoomToCb:[] //calbacks for when zoomTo is complete
		}
	},
	beforeDestroy:function(){

		//todo: change this strategy to not turn off overlays when heading to features page
		this.$store.dispatch('MAP_FEATURE_VISIBLE_CLEAR','all');
		this.$store.dispatch('MAP_LAYER_GROUP_VISIBLE_ON','zoning');
	},
	methods:{
		isReference:function(overlay){ // check if overlay has references
			if (!overlay.references || overlay.references.length < 1) return false
			for (let i=0,len=overlay.references.length;i<len;i++){
				if (overlay.references[i].description) return true
			}
			return false
		},
		routeLogin: function(){
			this.$router.push({
				name: 'auth', 
				params:{}
			});
		},
		routeOverlay: function(overlay){
			let bbox = this.parcel.bounds.bbox;
			let centerX = bbox[0] + (bbox[2] - bbox[0])/2;
			let centerY = bbox[1] + (bbox[3] - bbox[1])/2;

			//	update our route which will fetch the community plan
			this.$router.push({
				name: 'overlay', 
				params:{
					id: overlay.id
				},
				query:{
					lat: centerX.toFixed(5),
					lng: centerY.toFixed(5)
				}
			});
		},
		overlayLayerToggle: function(overlay){
			const key = this.overlayKey(overlay);
			if (!this.overlaysVisible[key]){

				let features = [];

				overlay.features.map((feat)=>{
					features.push({
						sourceLayer:'overlays',
						featureId: feat.id,
						properties:{
							layer_id: overlay.layerId,
							source_id: overlay.sourceId
						}
					});
					features.push({
						sourceLayer:'overlay_labels',
						properties:{
							resource_id: feat.id
						}
					});
				});

				this.overlaysVisible = {...this.overlaysVisible, [key]:features};

				const cb = ()=>{
					this.$store.dispatch('MAP_FEATURE_VISIBLE_ON',features);
				};

				if (this.$store.getters.mapZoomGet() > 16){
					this.$store.dispatch('MAP_FLY_TO',{
						zoom:15
					});
					this.zoomToCb = [...this.zoomToCb, cb];
				} else {
					cb();
				}
			} else {
				this.$store.dispatch('MAP_FEATURE_VISIBLE_OFF',[...this.overlaysVisible[key]]);
				this.overlaysVisible = {...this.overlaysVisible, [key]:false};
			}
		},
		overlayKey: function(overlay){
			return overlay.sourceId+'-'+overlay.layerId;
		},
		getCategoryIcon:function(category){
			if (overlayIcons[category])
				return overlayIcons[category]
		}		
	},
	watch:{
		zoomToDone:function(){
			if (this.zoomToCb && this.zoomToCb.length > 0){
				this.zoomToCb.map((cb)=>{
					cb();
				});
				this.zoomToCb = [];
			}
		},
		$route:function(toRoute, fromRoute){
			this.$store.dispatch('MAP_LAYER_GROUP_VISIBLE_OFF','zoning');
		},
	}
}

</script>

<style>
	.bg-gray{background-color:#FAFAFA;}
	.font-10{font-size:10px;}
	.censor-block{height:18px;width:100px;background-color:#455963;}
	.text-blur{color:transparent;text-shadow:0px 0px 10px #999;}
	.over-sign-in{position:absolute;top:0;left:0;right:0;bottom:0;background-color:rgba(55,71,79,0.2);}
	.over-sign-in-box{padding:12px 0;width:120px;margin:0 auto;
		text-align:center;color:#fff;}
	.section .feature{}
	.visible-icon{cursor:pointer;opacity:0.9;color:#9E9E9E;}
	.visible-icon:hover{opacity:1;color:#9E9E9E;}
	.visible-icon.active{color:#1A75D3;}
</style>


// WEBPACK FOOTER //
// src/components/parcel/parcel-overlays.vue